<template>
	<!-- 这是右边引入的表格 -->
	<div class="inspection-task-manage" :class="{'app-region blank-t-v blank-l-h blank-r-h': !communityId}">
		<a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
			<a-col :span="24" :xl="8">
				<a-row :gutter="[8, 8]">
					<a-col>
						<p>任务名称</p>
					</a-col>
					<a-col>
						<a-input placeholder="请输入巡检任务名称" v-model="table.search.task_name" allow-clear></a-input>
					</a-col>
				</a-row>
			</a-col>

			<a-col :span="24" :xl="8">
				<a-row :gutter="[8, 8]">
					<a-col>
						<p>设备类型</p>
					</a-col>
					<a-col>
						<a-select class="app-block" placeholder="请选择设备类型" v-model="table.search.device_type_id">
							<a-select-option :value="value.id" v-for="value in deviceOptions" :key="value.id">
								{{value.name}}</a-select-option>
						</a-select>
					</a-col>
				</a-row>
			</a-col>

			<a-col :span="24" :xl="8">
				<a-row :gutter="[8, 8]">
					<a-col>
						<p>任务期限</p>
					</a-col>
					<a-col>
						<a-range-picker valueFormat="YYYY-MM-DD" v-model="table.search.date"></a-range-picker>
					</a-col>
				</a-row>
			</a-col>

			<a-col :span="24" :xl="8">
				<a-row :gutter="[8, 8]">
					<a-col>
						<p>任务状态</p>
					</a-col>
					<a-col>
						<!-- 这个是绑定接口的选择列表 -->
						<a-select class="app-block" placeholder="请选择任务状态" v-model="table.search.task_state">
							<a-select-option :value='0'>{{taskStatus(0)}}</a-select-option>
							<a-select-option :value='1'>{{taskStatus(1)}}</a-select-option>
							<a-select-option :value='2'>{{taskStatus(2)}}</a-select-option>
						</a-select>
					</a-col>
				</a-row>
			</a-col>

			<a-col :span="24" :xl="8">
				<a-space>
					<a-button type="primary" @click="searchTable">查询</a-button>
					<a-button @click="resetSearchTable">重置</a-button>
				</a-space>
			</a-col>
		</a-row>

		<a-row class="mg-normal">
			<a-col>
				<a-space>
					<a-button type="primary" @click="newInspTask()">添加任务</a-button>
				</a-space>
			</a-col>
		</a-row>

		<a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data"
			rowKey="id" :pagination="table.page" @change="handlePageChange">
			<template slot="action" slot-scope="text, data">
				<a-space>
					<a-button type="link" @click="editInspTask(data)">编辑</a-button>
					<a-button type="link" @click="deleteInspTask(data)">删除</a-button>
				</a-space>
			</template>
		</a-table>
	</div>
</template>

<script>
	import Inspection from '@/io/inspection.js';
	import DeviceType from '@/io/device_type.js';
	import {
		taskStatus
	} from '@/io/dict.js';

	export default {
		name: 'InspectionTaskManage',
		props: {
			communityId: {
				type: Number,
				default: null
			},
		},
		data() {
			let self = this;
			return {

				taskStatus,
				table: {
					loading: false,
					search: {
						task_name: null,
						device_type_id: [],
						task_start_date: null,
						task_end_date: null,
						date: [],
						task_state: [],
					},

					page: {
						total: 0,
						current: 1,
						pageSize: 10,
						showQuickJumper: true,
						showSizeChanger: true,
						showTotal() {
							return `共${self.table.page.total}条`;
						}
					},
					data: [],
					columns: [

						{
							title: '项目名称',
							dataIndex: 'community_name',
						},
						{
							title: '任务名称',
							dataIndex: 'task_name',
						},
						{
							title: '设备类型',
							dataIndex: 'device_type.name',
						},
						// 有可能需要修改
						{
							title: '任务期限',
							dataIndex: 'task_start_date',
						},
						{
							title: '任务状态',
							dataIndex: 'taskStatus',
						},
						{
							title: '操作',
							scopedSlots: {
								customRender: 'action'
							},
						}
					]
				},
				deviceOptions: [],
			}
		},
		// 项目构建需要获取的不同社区的communityId
		watch: {
			communityId: {
				handler(newValue, oldValue) {
					if (newValue || this.$getCookie('communityId')) {
						this.searchTable();
					}
				},
				immediate: true
			}
		},
		activated() {
			if (this.communityId) {
				this.initData();
			}
		},
		mounted() {
			Promise.all([
				this.initDevice()
			]).then(() => {
				this.initData();
			});
		},
		methods: {
			//添加任务
			newInspTask() {
				this.table.page.current = 1;
				this.$router.push({
					name: 'NewInspTask'
				})
			},
			//编辑
			editInspTask(data) {
				this.$router.push({
					name: 'EditInspTask',
					params: {
						id: data.id
					},
				});
			},

			//删除
			deleteInspTask(data) {
				let self = this;
				this.$confirm({
					title: '提示',
					content: '确认删除此类型？',
					onOk() {
						Inspection.del(data.id).then(res => {
							self.initData();
						}).catch(err => {});
					}
				});
			},
			toPage(params) {
				if (this.communityId) {
					params = {
						...params,
						query: {
							community_id: this.communityId
						}
					}
				}
				this.$router.push(params);
			},
			searchTable() {
				this.table.page.current = 1;
				this.initData();
			},
			//这是搜索的是表格内的数据
			resetSearchTable() {
				this.table.search = {
					task_name: null,
					device_type_id: null,
					task_state: [],
					task_start_date: [],
					task_end_date: [],
					date: []
				};
				this.searchTable();
			},
			handlePageChange(page) {
				this.table.page.current = page.current;
				this.table.page.pageSize = page.pageSize;
				this.initData();
			},
			// 设备类型数据
			initDevice() {
				return DeviceType.listPage().then(res => {
					this.deviceOptions = res;
				}).catch(err => {})
			},
			initData() {
				this.table.search.task_start_date = this.table.search.date[0]
				this.table.search.task_end_date = this.table.search.date[1]
				this.table.loading = true;
				this.$emit('total', 0);
				Inspection.listPage(
					this.communityId,
					this.table.search.task_name,
					this.table.search.device_type_id,
					this.table.search.task_state,
					this.table.search.task_start_date,
					this.table.search.task_end_date,
					this.table.page.current,
					this.table.page.pageSize
				).then(res => {
					this.table.data = res.data.map(val => {
						val.taskStatus = taskStatus(val.status)
						return val;
					});
					this.table.page.total = res.meta.pagination.total;
					this.$emit('total', res.meta.pagination.total);
				}).catch(err => {}).finally(() => {
					this.table.loading = false;
				});
			},

		},
	}
</script>

<style lang="less" scoped>

</style>
